
export default {
  name: 'ClockChangeDial',
  props: {
    hour: {
      type: Number,
      required: true,
    },
    size: {
      type: Number,
      default: 18,
    },
    rewind: {
      type: Boolean,
      default: false,
    },
    ticking: {
      type: Boolean,
      default: false,
    },
    secondOffset: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    hourAngle() {
      return (this.hour % 12) * 30
    },
  },
}
